import { matchPredictSettingsOrganisationsPath, matchPredictSettingsUsersPath } from '@futrli/shared-services';
import { matchWorkspaceRoutePath, matchWorkspacesRoutePath } from '@futrli/predict-next/workspaces/utils/route-utils';

export type WorkspacesRouterTarget = 'redesigned-listing' | false;

export const getWorkspacesRouterTarget = (pathname: string): WorkspacesRouterTarget => {
  if (
    matchWorkspacesRoutePath(pathname, true) ||
    matchWorkspaceRoutePath(pathname, true) ||
    matchPredictSettingsOrganisationsPath(pathname) ||
    matchPredictSettingsUsersPath(pathname)
  ) {
    return 'redesigned-listing';
  }

  return false;
};
